import { TOP_SIDE, BOTTOM_SIDE, COMBINED, TWO_SIDES } from 'shared/product_tabs/tab_stencils/data/constants';

export const getStencilsTitle = (stencilsSide) => {
  switch (stencilsSide) {
    case TOP_SIDE:
      return 'TOP';
    case BOTTOM_SIDE:
      return 'BOTTOM';
    case COMBINED:
      return 'COMBINED';
    case TWO_SIDES:
      return 'TOP & BOTTOM';
    default:
      return '';
  }
};
